import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { BaseHttpService } from './base-http.service';
import { ConsultantSalary } from '../models/consultant.model';

@Injectable({
  providedIn: 'root'
})
export class ConsultantSalaryService extends BaseHttpService {
  constructor(http: HttpClient) {
    super(http);
  }

  public save(salary: ConsultantSalary) {
    return firstValueFrom(this.http.post<ConsultantSalary>(`${this.baseApiUrl}/consultantsalary/save`, salary));
  }

  public delete(id: string) {
    return firstValueFrom(this.http.delete<boolean>(`${this.baseApiUrl}/consultantsalary/${id}`));
  }
}
